import * as settings from '@/settings';
import { IFsFileType } from '@r3f-component-data-structure';
import { filestore } from '../store';
import { formatBytes } from '../utils';
export class FsBaseFile {
    fs;
    id;
    type = IFsFileType.Unknown;
    baseUrl;
    size = 0;
    name = '';
    constructor(fileId, projectId, name) {
        this.fs = filestore;
        this.id = fileId;
        this.name = name;
        this.baseUrl = `${settings.FILESTORE_URL}/proj-${projectId}/${this.id}`;
    }
    getSize() {
        return formatBytes(this.size);
    }
    async getFilesForBundler() {
        return Promise.resolve([]);
    }
}
